<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
.fontP {
  font-family : 'Poppins';
}

.fontPB {
  font-family : 'PoppinsBold';
}

.fontPL {
  font-family : 'PoppinsLight';
}

.fontPM {
  font-family : 'PoppinsMedium';
}

.fontPR {
  font-family : 'PoppinsRegular';
}

.fontPS {
  font-family : 'PoppinsSemiBold';
}

.fontNB {
  font-family : 'NotoSansBold';
}

.fontOR {
  font-family : 'OreganoRegular';
}

.fontGB {
  font-family : 'GilroyExtraBold';
}

.fontRB {
  font-family : 'RobotoBold';
}

.fontMB {
  font-family : 'MontserratBold';
}

.fontMR {
  font-family : 'MontserratRegular';
}

.fontML {
  font-family : 'MontserratLight';
}

.fontADB {
  font-family : 'AbrilDisplayBold';
}

.el-form {
  font-family : 'PoppinsMedium';
}

.formLabel {
  font-family : 'PoppinsMedium';
}

/*.el-form-item__content{
    text-align:center;
  }*/

.el-dialog {
  border-radius : 20px;
}

html, body, ul, li, p {
  margin  : 0;
  padding : 0;
  border  : none;
  outline : none;
}

ul, li {
  list-style : none;
}

#app {
  font-family             : 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing  : antialiased;
  -moz-osx-font-smoothing : grayscale;
  color                   : #2c3e50;
}

.el-popup-parent--hidden {
  padding-right : 0 !important;
}

.el-icon-google {
  background      : url('./assets/img/google@2x.png') center no-repeat;
  background-size : contain;
}

.el-icon-google:before {
  content    : "替";
  font-size  : 16px;
  visibility : hidden;
}

.el-icon-fb {
  background      : url('./assets/img/Facebook@2x.png') center no-repeat;
  background-size : contain;
}

.el-icon-fb:before {
  content    : "替";
  font-size  : 16px;
  visibility : hidden;
}

.el-icon-lang {
  background      : url('./assets/img/lang.png') center no-repeat;
  background-size : cover;
}

.el-icon-lang:before {
  content    : "替";
  font-size  : 16px;
  visibility : hidden;
}

.hv:hover {
  cursor : pointer;
}

.fcb {
  display         : flex;
  align-items     : center;
  justify-content : space-between;
}

.fca {
  display         : flex;
  align-items     : center;
  justify-content : space-around;
}

.fl {
  float : left;
}

.fr {
  float : right;
}

.tr {
  text-align : right;
}

.tc {
  text-align : center;
}

.ti10 {
  text-indent : 10px;
}

.clearfix:after {
  visibility : hidden;
  display    : block;
  font-size  : 0;
  content    : ".";
  clear      : both;
  height     : 0;
}

* html .clearfix {
  zoom : 1;
}

*:first-child + html .clearfix {
  zoom : 1;
}

.el-input > .el-input__inner, input {
  height         : 40px;
  font-size      : 16px;
  line-height    : 16px;
  padding        : 12px 15px;
  vertical-align : middle;
}

.noData {
  line-height : 80px;
  text-align  : center;
  font-size   : 20px;
}

.textline1 {
  white-space   : nowrap;
  overflow      : hidden;
  text-overflow : ellipsis;
}

.lineTitle {
  position    : relative;
  width       : 100%;
  height      : 80px;
  font-size   : 42px;
  color       : #7B5C55;
  padding-top : 50px;
}

.lineTitle > div {
  padding : 0 10px;
}

.lineTitle > div:first-child {
  height      : 48px;
  line-height : 48px;
  display     : inline-block;
  width       : auto;
  position    : absolute;
  top         : 36px;
  z-index     : 2;
}

.lineTitle > div:nth-child(2) {
  background  : #fff;
  display     : inline-block;
  width       : auto;
  position    : absolute;
  height      : 30px;
  line-height : 30px;
  top         : 60px;
  color       : #fff;
  z-index     : 1;
}

.des ul, .des li {
  list-style : initial;
}

.des ul {
  margin-left : 20px;
}

.dpn {
  display : none !important;
}

/*滚动条宽度*/
.scroll::-webkit-scrollbar, body::-webkit-scrollbar {
  width : 0px;
}

.scroll::-webkit-scrollbar-thumb, body::-webkit-scrollbar-thumb {
  border-radius      : 5px;
  -webkit-box-shadow : inset 0 0 5px rgba(0, 0, 0, 0.2);
  background         : rgba(0, 0, 0, 0.2);
}

.scroll::-webkit-scrollbar-track, body::-webkit-scrollbar-track {
  -webkit-box-shadow : inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius      : 0;
  background         : rgba(0, 0, 0, 0.1);
}

.el-container {
  margin : 0 auto;
}

/*手机*/
@media screen and (max-width : 768px) {
  .fcb {
    display : block;
  }

  .el-button {
    padding : 12px 10px;
  }

  .el-message-box {
    width : 90%;
  }

  .el-form-item__label {
    line-height : 30px;
  }

  .el-form-item__content .el-button {
    width   : 30%;
    margin  : 0 auto;
    display : block;
  }

  .el-message {
    min-width : 20px;
    width     : 90%;
  }

  .el-input > .el-input__inner, input {
    padding     : 12px 10px;
    height      : 40px;
    font-size   : 16px;
    line-height : 16px;
  }

  .lineTitle {
    position  : relative;
    width     : 90%;
    margin    : 0 auto;
    height    : 50px;
    font-size : 24px;
    padding   : 10px 0;
  }

  .lineTitle > div:first-child {
    height      : 48px;
    line-height : 48px;
    display     : inline-block;
    width       : 100%;
    text-align  : center;
    position    : relative;
    top         : 0;
    z-index     : 2;
  }

  .lineTitle > div:nth-child(2) {
    display : none;
  }
}

/*平板*/
@media screen and (min-width : 768px) and (max-width : 992px) {
  .lineTitle {
    position    : relative;
    font-size   : 34px;
    width       : 100%;
    height      : 80px;
    padding-top : 20px;
  }

  .lineTitle > div {
    padding : 0 10px;
  }

  .lineTitle > div:first-child {
    height      : 48px;
    line-height : 48px;
    display     : inline-block;
    width       : auto;
    position    : absolute;
    top         : 22px;
    z-index     : 2;
  }

  .lineTitle > div:nth-child(2) {
    background  : #fff;
    display     : inline-block;
    width       : auto;
    position    : absolute;
    height      : 30px;
    line-height : 30px;
    top         : 46px;
    color       : #fff;
    z-index     : 1;
  }
}

/*中等屏幕*/
@media screen and (min-width : 992px) and (max-width : 1200px) {
  .lineTitle {
    font-size : 36px;
  }

  .lineTitle > div:nth-child(2) {
    display : inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue